// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vSmY2","title":"styles_title__3xCtk"};